import React, { useState } from 'react'
import { AddCategoryComponent } from '../Components/Category/AddCategoryComponent';
import { EditCategoryComponent } from '../Components/Category/EditCategoryComponent';
import { Col, Row } from 'antd';
import { AllCategoryLayoutComponent } from '../Components/Category/AllCategoryLayoutComponent';
// ======================================================================
export const Category = ({ setLoading, showMessage }) => {
    // ======================================================================
    const [view, setView] = useState('All');
    const [selectedId, setSelectedId] = useState(0);
    const [selectedTitle, setSelectedTitle] = useState(0);
    // ======================================================================
    return (
        <>
            {view === "All" ?
                <AllCategoryLayoutComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    parentId={-1}
                    isShowAddSubCategory={true}
                    isShowEdit={true}
                    isShowDelete={true}
                    onRowDeleted={() => { window.location.reload(); setView("All") }}
                    editClick={(id) => { setSelectedId(id); setView("Edit"); }}
                    addSubCategoryClick={(id, title) => { setSelectedId(id); setSelectedTitle(title); setView("Add"); }}
                    isLoadObjectInstanceCategories={false}
                    isShowCheckBox={false}
                /> : <></>
            }
            {view === "Add" ?
                <AddCategoryComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    parentId={selectedId}
                    parentTitle={selectedTitle}
                    rowInserted={() => { setView("All") }}
                    cancelInsert={() => setView("All")}
                /> : <></>}
            {view === "Edit" ?
                <EditCategoryComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    id={selectedId}
                    rowUpdated={() => { setView("All") }}
                    cancelEdit={() => { setView("All") }}
                /> : <></>}
        </>
    )
}
